import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, DrivelogUser } from './auth.service';

@Injectable()
export class MockAuthService extends AuthService {
  private router = inject(Router);
  private _user = signal<DrivelogUser | null>(null);

  isAuthenticated(): boolean { return this._user() !== null; }
  getToken(): string | null {
    const id = this._user()?.id;
    return id ? `mock-token:${id}` : null;
  }
  getUser(): DrivelogUser | null { return this._user(); }

  login(): void { this.router.navigate(['/login']); }

  // Mock tokens don't expire; a 401 here means the in-memory session was already cleared.
  async refreshToken(): Promise<boolean> { return this.isAuthenticated(); }

  logout(): void {
    this._user.set(null);
    this.router.navigate(['/login']);
  }

  mockLogin(user: DrivelogUser): void {
    this._user.set(user);
  }
}
